export default __webpack_public_path__ + "static/product_costing-aa62498ae6d02caea7ab95b4de5ff44e.png";